export function splitArray(list, chunkLength) {
  const chunks = [];
  let chunk = [];
  let i = 0;
  let l = 0;
  let n = list.length;
  while (i < n) {
    chunk.push(list[i]);
    l++;
    if (l === chunkLength) {
      chunks.push(chunk);
      chunk = [];
      l = 0;
    }
    i++;
  }
  chunk.length && chunks.push(chunk);
  return chunks;
}
